import { render, staticRenderFns } from "./QRIcon.vue?vue&type=template&id=1d249b09&scoped=true"
import script from "./QRIcon.vue?vue&type=script&lang=js"
export * from "./QRIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d249b09",
  null
  
)

export default component.exports